import { classNames } from "primereact/utils";
import { useAppContext } from "../../../../AppContext";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { useReviewQuote } from "../../hooks/useReviewQuote";
import {
  formatAverageRating,
  getReviewsCountLabel,
} from "../../utils/reviewUtility";
import { ReviewsDialog } from "../ReviewsDialog/ReviewsDialog";
import { StarRating } from "../StarRating/StarRating";
import styles from "./ReviewQuote.module.scss";

/** The studio's rating and a rotating review quote on the home screen. */
export const ReviewQuote = () => {
  const { selectedStudio } = useAppContext();
  const {
    summary,
    currentQuote,
    quoteIndex,
    isDialogOpen,
    openDialog,
    closeDialog,
  } = useReviewQuote(selectedStudio?.id);

  if (!summary) {
    return null;
  }

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        aria-label="Виж всички ревюта"
        className={styles.root}
        onClick={openDialog}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openDialog();
          }
        }}
      >
        <div className={styles.rating}>
          <StarRating value={summary.averageRating} />
          <span>
            {`${formatAverageRating(summary.averageRating)} от ${getReviewsCountLabel(summary.count)}`}
          </span>
        </div>

        <RenderWhen condition={!!currentQuote}>
          <div key={currentQuote?.id} className={styles.quote}>
            <p className={styles.quoteText}>{`„${currentQuote?.comment}“`}</p>
            <span className={styles.author}>— {currentQuote?.reviewerName}</span>
          </div>
        </RenderWhen>

        <RenderWhen condition={(summary.quotes?.length ?? 0) > 1}>
          <div className={styles.dots} aria-hidden="true">
            {summary.quotes.map((quote, index) => (
              <span
                key={quote.id}
                className={classNames(styles.dot, {
                  [styles.active]: index === quoteIndex,
                })}
              />
            ))}
          </div>
        </RenderWhen>
      </div>

      <ReviewsDialog
        visible={isDialogOpen}
        studioId={selectedStudio?.id}
        summary={summary}
        onHide={closeDialog}
      />
    </>
  );
};
